import publicacoes from "./publicacoesNovidades.json";

// A origem é o acesso alterado. Cada publicação segue este público aprovado.
const publicosPorOrigem = {
  geral: ["user", "analyst", "superintendent", "admin"],
  escola: ["user", "analyst", "superintendent", "admin"],
  analista: ["analyst", "superintendent", "admin"],
  sre: ["superintendent", "admin"],
  admin: ["superintendent", "admin"],
};

export function novidadeVisivelPara(publicacao, perfil) {
  return Boolean(publicacao && Object.prototype.hasOwnProperty.call(publicosPorOrigem, publicacao.origem)
    && publicosPorOrigem[publicacao.origem].includes(perfil));
}

export const nomesAcessos = { user: "Escola", analyst: "Analista", superintendent: "SRE", admin: "Admin" };
export const nomesOrigens = { geral: "Todos os acessos", escola: "Escola", analista: "Analista", sre: "SRE", admin: "Admin" };
export const novidades = publicacoes;

export function imagemNovidade(src) {
  return src?.startsWith("/novidades/") ? `${process.env.PUBLIC_URL || ""}${src}` : src;
}
